module.exports = __webpack_public_path__ + "img/ticket.c5db3edf.png";